import { useEffect } from "react";

export function useSyncronizer(trigger: any, callBack: any) {
  useEffect(() => {
    if (!trigger) return;
    callBack();
  }, [trigger]);
}
